export const helpCenterArticles = {
  permittedUrl: {
    url: "https://help.shakebugs.com/en/articles/10091201-why-do-we-use-permitted-urls-protecting-your-api-keys",
    id: 10091201,
  },
  sentryExtension: {
    url: "https://help.shakebugs.com/en/articles/9891543-sentry-extension",
    id: 9891543,
  },
  deprecatedClientKeys: {
    url: "https://help.shakebugs.com/en/articles/10080315-why-did-shake-switch-from-client-id-to-api-keys",
    id: 10080315,
  },
  approvedDomains: {
    url: "https://help.shakebugs.com/en/articles/10080319-use-permitted-domains-to-limit-access-and-avoid-spam",
    id: 10080319,
  },
  rules: {
    url: "https://help.shakebugs.com/en/articles/7979662-defining-rules-define-rules-adding-a-rule",
    id: 7979662,
  },
  commonComments: {
    url: "https://help.shakebugs.com/en/articles/7983651-common-comments-auto-reply-messages",
    id: 7983651,
  },
  blockUsers: {
    url: "https://help.shakebugs.com/en/articles/7919363-blocking-spammy-users",
    id: 7919363,
  },
  activityHistory: {
    url: "https://help.shakebugs.com/en/articles/10717951-activity-history",
    id: 10717951,
  },
  integrationsTroubleshooting: {
    url: "https://help.shakebugs.com/en/articles/15394173-shake-integrations-setup-troubleshooting",
    id: 15394173,
  },
  pushNotifAndroid: {
    url: "https://help.shakebugs.com/en/articles/7931355-how-to-enable-push-notifications-on-android",
    id: 7931355,
  },
  pushNotifIos: {
    url: "https://help.shakebugs.com/en/articles/7931290-how-to-enable-push-notifications-on-ios",
    id: 7931290,
  },
  activityHistoryNotAvailable: {
    url: "https://help.shakebugs.com/en/articles/11104964-activity-history-is-not-available",
    id: 11104964,
  },
  roles: {
    url: "https://help.shakebugs.com/en/articles/12555851-what-s-the-difference-between-admin-member-and-guest",
    id: 12555851,
  },
  aiPrivacy: {
    url: "https://help.shakebugs.com/en/articles/12298701-privacy-framework-for-sheldon-ai-assistant",
    id: 12298701,
  },
  sdkInitializationsAndAddons: {
    url: "https://help.shakebugs.com/en/articles/12577381-add-ons-pricing-faq",
    id: 12577381,
  },
  manuallyAddingTickets: {
    url: "https://help.shakebugs.com/en/articles/13913830-manual-ticket-creation-create-new-ticket-manually",
    id: 13913830,
  },
  sdkSetupMisconfigurations: {
    url: "https://help.shakebugs.com/en/articles/13928065-8-common-shake-sdk-setup-misconfigurations",
    id: 13928065,
  },
};
